module.exports = __webpack_public_path__ + "img/2016.790523d5.jpg";